import { render, staticRenderFns } from "./DealerDetails.vue?vue&type=template&id=e06e0daa"
import script from "./DealerDetails.vue?vue&type=script&lang=js"
export * from "./DealerDetails.vue?vue&type=script&lang=js"
import style0 from "./DealerDetails.vue?vue&type=style&index=0&id=e06e0daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports